'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectedDroppable = require('./connected-droppable');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_connectedDroppable).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/droppable/index.js
// module id = 2994
// module chunks = 0